// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"35bada0f","631":"1e403d88"}[chunkId] + ".chunk.js";
};